import moment from "moment";

export const DEFAULT_ADULTS_ROOM_SEARCH = 2;
export const DEFAULT_CHILDREN_ROOM_SEARCH = 0;
export const DEFAULT_ROOMS_ROOM_SEARCH = 1;
export const DEFAULT_CHECKIN_DATE = moment(
  new Date().setDate(new Date().getDate() + 1)
);
export const DEFAULT_CHECKOUT_DATE = moment(
  new Date().setDate(new Date().getDate() + 2)
);

export const LODGE_DEFAULTS = {
  ADULTS: 2,
  CHILDREN: 0,
  ROOMS: 1,
  CHECK_IN: moment(new Date()).add(1, "days"),
  CHECK_OUT: moment(new Date()).add(2, "days"),
};

export const adultSelectOptions = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
];

export const childrenSelectOptions = [
  { label: "0", value: 0 },
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
];

export const roomSelectOptions = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
];
